import type { SEOData, SEOFilters } from './types';
import type { AllFilters } from './filters';
import { isPlpCardType, PlpCardType } from './constants';
import { getRequiredSEO } from './required';
import { getOptionalSEO } from './optional';

export const getSEOData = (cardType: string, filters: SEOFilters, isDigital = false): SEOData => {
  const possibleTypeKey = cardType?.toUpperCase();
  let typeKey: PlpCardType | undefined;
  if (isDigital) {
    typeKey = 'DIGITAL_SAVE_THE_DATE';
  } else if (isPlpCardType(possibleTypeKey)) {
    typeKey = possibleTypeKey;
  }

  const orderedFilters = [
    ...(filters.is_vow_renewal ? ['is_vow_renewal'] : []),
    ...(filters.has_foil ? ['has_foil'] : []),
    ...(filters.is_letterpress ? ['is_letterpress'] : []),
    ...(filters.has_magnet ? ['has_magnet'] : []),
    ...(filters.is_portrait ? ['is_portrait'] : []),
    ...(filters.is_landscape ? ['is_landscape'] : []),
    ...(filters?.motifs || []),
    ...(filters?.seo_colors || []),
    ...(filters.has_custom_photo ? ['has_custom_photo'] : []),
    ...(filters.has_no_custom_photo ? ['has_no_custom_photo'] : []),
    ...(filters?.silhouettes || []),
  ];
  const mainFilter = orderedFilters[0]?.toLowerCase() as AllFilters;
  // If there are multiple filters selected, show the card type's defaults.
  const filterKey = orderedFilters.length === 1 ? mainFilter : undefined;

  return {
    // The REQUIRED data used in meta tags & page content. Will be defined for all card types and filters.
    ...getRequiredSEO(typeKey, filterKey),
    // The OPTIONAL copy displayed at the bottom of the page. Defined for all card types, but not for all filters.
    ...getOptionalSEO(typeKey, filterKey),
  };
};
